import * as e from "react";
import { forwardRef as r } from "react";
const n = r(
  function(L, t) {
    return /* @__PURE__ */ e.createElement(
      "svg",
      {
        fill: "none",
        ref: t,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...L
      },
      /* @__PURE__ */ e.createElement("circle", { cx: 12.0357, cy: 6.03571, fill: "#000", r: 2.03571 }),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M12.5 15L11.5 17.5L9 20M12.5 15L15.0108 16.6739C15.3229 16.8819 15.535 17.2099 15.5967 17.58L16 20M12.5 15V10.5C12.5 10.2239 12.2761 10 12 10H8.91421C8.649 10 8.39464 9.89464 8.20711 9.70711L7 8.5",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 2.03571
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M19.3202 8.59625C19.6514 8.14205 19.5517 7.50534 19.0975 7.17411C18.6433 6.84288 18.0066 6.94257 17.6754 7.39677L19.3202 8.59625ZM15.0003 9.30392L13.9824 9.30589L13.9863 11.3416L15.0042 11.3396L15.0003 9.30392ZM16.8793 10.2158L16.0569 9.61611L16.8793 10.2158ZM16.6778 10.3185L16.6798 11.3364L16.6778 10.3185ZM16.8793 10.2158L17.7017 10.8156L19.3202 8.59625L18.4978 7.99651L17.6754 7.39677L16.0569 9.61611L16.8793 10.2158ZM16.6778 10.3185L16.6758 9.30069L15.0003 9.30392L15.0022 10.3218L15.0042 11.3396L16.6798 11.3364L16.6778 10.3185ZM16.8793 10.2158L16.0569 9.61611C16.2011 9.41832 16.431 9.30116 16.6758 9.30069L16.6778 10.3185L16.6798 11.3364C17.0839 11.3356 17.4635 11.1422 17.7017 10.8156L16.8793 10.2158Z",
          fill: "#000"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M4.98793 7.34851C4.83321 7.1033 5.07586 5.85311 5.98595 5.27888C6.89603 4.70465 8.06701 4.92576 8.28362 5.26906C8.50023 5.61236 8.19569 6.76447 7.28561 7.33869C6.74483 7.6799 6.09009 7.70566 5.61529 7.61894L5.54713 7.60546C5.25761 7.54382 5.04623 7.44091 4.98793 7.34851Z",
          fill: "#000",
          stroke: "#000",
          strokeWidth: 0.626807
        }
      )
    );
  }
);
export {
  n as BetBuilderBadgeAmericanPassing
};
